import { z } from 'zod';

export const citationSchema = z.object({
  text: z.string(),
  entity: z.string(),
  document_id: z.string(),
  document_kind: z.string(),
  document_type: z.enum(['pdf', 'html', 'markdown']),
  document_location: z.string(),
  document_name: z.string(),
  pages: z.optional(z.array(z.number())),
  score: z.number(),
  published_date: z.string(),
  period: z.string(),
  year: z.number(),
});

const citationResponseSchema = z.object({
  total_count: z.number(),
  citations: z.array(citationSchema),
});

export const citation = {
  citationGroup: {
    path: (id: string, params: URLSearchParams) =>
      `citations/v1/group/${encodeURIComponent(id)}?${params}`,
    schema: citationResponseSchema,
  },
};

export type Citation = z.infer<typeof citationSchema>;
export type CitationResponse = z.infer<typeof citationResponseSchema>;
